<template>
  <div>
    <v-btn
        v-if="!hasResult"
        id="updateBtn"
        v-test="{ btn: 'update' }"
        class="ma-2"
        color="primary"
        :disabled="loading"
        @click.stop="openConfirmDialog">
      {{ $t('Подвести итоги') }}
    </v-btn>
    <confirm-dialog
        v-if="confirmDialog.show"
        :dialog-prop="confirmDialog"
        max-width="800"
        @close="closeDialog('confirmDialog')">
      <template v-slot:additional>
        <v-row>
          <v-col class="text-left ml-2 pl-0">
            <text-view
                :label="$t('Итог торгов')"
                :display="tradeResult" />
            <text-view
                v-if="result.orders.filter(o => !!o.isWinner).length &&
                  result.tradeResultType !== TRADE_RESULT_TYPES.FAILED"
                class-flex="my-0 py-0"
                :label="$t('Победитель')"
                :display="' '" />
          </v-col>
          <v-col cols="12">
            <v-expansion-panels>
              <v-expansion-panel
                  v-for="order in result.orders.filter(o => !!o.isWinner)"
                  :key="order.orderId">
                <v-expansion-panel-header>
                  <div>
                    <v-icon>
                      check_box
                    </v-icon>
                    {{ order.organizationName }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content eager>
                  <v-row class="py-2">
                    <text-view
                        v-if="order.deliveryBasisDescription"
                        :cols="12"
                        align-self="center"
                        :label="$t('Порт/место назначения')"
                        :display="order.deliveryBasisDescription" />
                    <v-col>
                      <v-data-table
                          :key="order.orderId"
                          :headers="headers"
                          :items="order.premiums || []"
                          :items-per-page="nestedItemsPerPage"
                          item-key="positionId"
                          disable-sort-by
                          dense
                          :locale="systemLocale">
                        <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                        <template v-slot:item.positionDescription="{ item }">
                          {{ item.positionDescription }}
                        </template>
                        <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                        <template v-slot:item.premium="{ item }">
                          {{ item.premium }}
                        </template>
                        <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                        <template v-slot:item.premiumWithDelivery="{ item }">
                          {{ item.premiumWithDelivery }}
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </template>
    </confirm-dialog>
  </div>
</template>

<script>
  import Vue from 'vue'
  import ConfirmDialog from '@/components/reused/common/ConfirmDialog.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import { TRADE_RESULT_TYPES } from '@/constants/business'
  import { TRADE_RESULT_TYPE_EDIT_ENUM } from '@/constants/enums'

  export default {
    components: {
      ConfirmDialog,
      TextView
    },
    props: {
      result: {
        type: Object,
        required: true,
        default: () => ({
          orders: [],
          tradeResultType: null
        })
      },
      isFixPremium: {
        type: Boolean,
        required: true
      },
      showDeliveryBasises: {
        type: Boolean,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      },
      hasResult: {
        type: Boolean,
        default: false
      },
      saveResults: {
        type: Function,
        default: () => {}
      }
    },
    data () {
      return {
        TRADE_RESULT_TYPES,
        nestedItemsPerPage: 5,
        confirmDialog: {
          show: false,
          text: null,
          callback: null,
          warning: true
        }
      }
    },
    computed: {
      headers () {
        return [
          { text: this.$t('Наименование позиции'), sortable: false, value: 'positionDescription' },
          { text: this.premiumHeader, sortable: false, value: this.showDeliveryBasises ? 'premiumWithDelivery' : 'premium' }
        ]
      },
      tradeResult () {
        return this.$t(this.result.tradeResultType
          ? TRADE_RESULT_TYPE_EDIT_ENUM[this.result.tradeResultType]
          : TRADE_RESULT_TYPE_EDIT_ENUM[TRADE_RESULT_TYPES.UNSET])
      },
      premiumHeader () {
        const premiumLabel = this.showDeliveryBasises
          ? this.isFixPremium
            ? 'Значение цены в базисе поставки'
            : 'Значение дифференциала в базисе поставки'
          : this.isFixPremium
            ? 'Цена за единицу в валюте Контракта'
            : 'Значение дифференциала'

        return this.$t(premiumLabel)
      }
    },
    methods: {
      // проверка всех условий перед сохранением
      validateResult: function () {
        if (this.result.tradeResultType === TRADE_RESULT_TYPES.UNSET) {
          throw new Vue.errorsTypes.ValidationError(this.$t('Результат торгов не указан.'))
        }
        const selected = this.result.orders.filter(w => w.isWinner) || []
        if (!selected.length &&
          this.result.tradeResultType === TRADE_RESULT_TYPES.WINNER_SELECTED) {
          throw new Vue.errorsTypes.ValidationError(this.$t('Победитель не выбран.'))
        }
        if (selected.length &&
          this.result.tradeResultType === TRADE_RESULT_TYPES.FAILED) {
          throw new Vue.errorsTypes.ValidationError(this.$t('Победитель не может быть выбран с данным результатом торгов.'))
        }
        if (selected.length > 1) {
          throw new Vue.errorsTypes.ValidationError(this.$t('Может быть выбран только один победитель.'))
        }
      },
      openConfirmDialog: function () {
        try {
          this.validateResult()
          this.confirmDialog.text = this.$t('По данной торговой процедуре будут подведены итоги с нижеуказанным результатом. Продолжить?')
          this.confirmDialog.callback = this.saveResults
          this.confirmDialog.warning = true
          this.confirmDialog.show = true
        } catch (error) {
          this.throwIfNotValidationError(error)
        }
      }
    }
  }
</script>
